/* IMPORT */
import { DIRTY_MAYBE_YES, UNAVAILABLE, UNINITIALIZED } from '../constants.js';
import Observable from './observable.js';
import Observer from './observer.js';
import { callStack, Stack } from '../methods/debugger.js';
/* MAIN */
class Memo extends Observer {
    /* CONSTRUCTOR */
    constructor(fn, options) {
        super();
        this.fn = fn;
        this.observable = new Observable(UNINITIALIZED, options, this);
        const { stack } = options ?? { stack: callStack('Memo init') };
        if (options?.sync === true) {
            this.sync = true;
            this.update(stack);
        }
    }
    /* API */
    run(stack) {
        const result = super.refresh(this.fn, stack);
        if (!this.disposed && this.observables.empty()) {
            this.disposed = true;
        }
        if (result !== UNAVAILABLE) {
            this.observable.set(result);
        }
    }
    stale(status, stack) {
        const statusPrev = this.status;
        if (statusPrev >= status)
            return;
        this.status = status;
        if (statusPrev === DIRTY_MAYBE_YES)
            return;
        this.observable.stale(DIRTY_MAYBE_YES, stack);
    }
}
/* EXPORT */
export default Memo;
